import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-edit\"><path d=\"M21 19.969H3.75a.75.75 0 00-.75.75v.843c0 .104.084.188.188.188h18.375a.188.188 0 00.187-.188v-.843a.75.75 0 00-.75-.75zM6.415 18a.953.953 0 00.14-.012l3.943-.691a.23.23 0 00.124-.066l9.935-9.935a.233.233 0 000-.33l-3.895-3.898A.232.232 0 0016.495 3a.232.232 0 00-.166.068l-9.935 9.935a.238.238 0 00-.066.124l-.691 3.943a.785.785 0 00.22.698c.155.15.35.232.558.232z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol